
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","viewBox":"0 0 34 34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.67 12.34A1.67 1.67 0 1018 10.67a1.68 1.68 0 001.67 1.67zM11.67 6.36A1.68 1.68 0 1010 4.69a1.67 1.67 0 001.67 1.67zM19.67 6.36A1.68 1.68 0 1019.69 3a1.68 1.68 0 00-.02 3.36zM14.67 15.36a1.68 1.68 0 10.02-3.36 1.68 1.68 0 00-.02 3.36z","fill":"#000"}}),_c('path',{attrs:{"d":"M11.55 18v5.53L15.96 27l4.49-3.47V18h-8.9z","stroke":"#000","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    